<template>
  <div>
    <v-toolbar v-if="screenSize === 'tablet' || screenSize === 'mobile'" dark :color="this.$gf.headerColor()">
      <v-app-bar-nav-icon @click="openNav = !openNav"></v-app-bar-nav-icon>
      <div class="help-icon text-right" v-on:click="redirectOn()" title="Help and Resources">
      <img src="/static/resources/senso-help-and-resources-icon-white.png" alt="Help Icon"
        v-if="$globalConfig.APP_NAME === 'senso'" />
      <img src="/static/resources/help-and-resources-icon-white.png" alt="Help Icon" v-else />
      <span><b>Help and Resources</b></span>
    </div>
    </v-toolbar>
    <v-toolbar v-else-if="isLoggedIn" dark :color="this.$gf.headerColor()">
      <v-toolbar-items>
        <v-btn text to="/partner/users">Dashboard</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-if="isPartnerLevel1 && $globalConfig.APP_NAME === 'senso'">
        <v-btn text to="/partner/tier2partners">Partner</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-if="isPartnerLevel && $globalConfig.APP_NAME === 'senso'">
        <v-btn text to="/partner/reports">Reports</v-btn>
        <v-btn text to="/partner/courses">Courses</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-if="isPartnerLevel && $globalConfig.APP_NAME === 'partner'">
        <v-btn text to="/partner/account-manager">Account Manager</v-btn>
        <v-btn text to="/partner/courses">Create Courses</v-btn>
        <v-btn text to="/partner/reports">Reports</v-btn>
        <v-btn text to="/profile/profile">Profile</v-btn>
      </v-toolbar-items>
      <!-- <v-toolbar-items v-if="(isPartnerLevel || isPartnerLevel1) && !isAccountManager">
        <v-btn text to="/partner/notification">Settings</v-btn>
      </v-toolbar-items> -->
      <div class="flex-grow-1"></div>
      <div class="help-icon" v-on:click="redirectOn()" title="Help and Resources">
      <img src="/static/resources/senso-help-and-resources-icon-white.png" alt="Help Icon"
        v-if="$globalConfig.APP_NAME === 'senso'" />
      <img src="/static/resources/help-and-resources-icon-white.png" alt="Help Icon" v-else />
      <span><b>Help and Resources</b></span>
    </div>
    <img src="/static/resources/top-header-divider.png" alt="Help Icon" class="header-divider">
      <span class="mr-4">Logged in as: {{ level }}</span>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn icon @click="logout">
          <v-icon>fa-sign-out-alt</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <transition name="nav-slide-down">
      <div
        v-if="this.openNav === true && this.screenSize === 'mobile' || this.openNav === true && this.screenSize === 'tablet'">
        <div class="nav-menu-container">
          <v-card style="padding: 10px 15px" flat to="/partner/users"> Dashboard </v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel1" to="/partner/tier2partners">Partner</v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel1" to="/partner/reports">Reports</v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel1" to="/partner/courses">Courses</v-card>

          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel" to="/partner/account-manager">Account Manager</v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel" to="/partner/courses">Create Courses</v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel" to="/partner/reports">Reports</v-card>
          <v-card style="padding: 10px 15px" flat v-if="isPartnerLevel" to="/partner/profile">Profile</v-card>

          <v-card style="padding: 10px 15px" flat to="/partner/notification" v-if="isPartnerLevel || isPartnerLevel1">Settings</v-card>

          <span style="padding: 10px 15px">Logged in as: {{ level }}</span>
          <v-btn icon @click="logout" style="background: #000000">
            <v-icon>fa-sign-out-alt</v-icon>
          </v-btn>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import { screensize } from '@/utils/screensize.js';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();


export default {
  name: 'PartnerHubNavigation',
  data() {
    return {
      screenSize: currentScreenSize || 'desktop',
      user: this.$store.getters.user.first_name,
      openNav: false,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    level: function () {
      const user = this.$store.getters.user;
      return user.first_name + ' ' + user.last_name;
    },
    userName: function () {
      return this.$store.getters.isLoggedIn;
    },
    showAdmin: function () {
      return this.$store.getters.admin;
    },
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    },
    isPartnerLevel1: function () {
      if (this.$store.getters.partnerLevel1 == true) {
        return true;
      } else {
        return false;
      }
    },
    isAccountManager: function () {
      if (this.$store.getters.level == 5) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.setEventBus();

    this.handleResize();
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        localStorage.removeItem('todos');
        this.$router.push('/login');
      });
    },
    setEventBus() {
      EventBus.$on('DRAWER_STATE', (payload) => {
        this.notificationDrawer = payload;
      });
    },
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    redirectOn(){
      this.$router.push("/resources");
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    this.screenSize = null;
  },
};
</script>
<style scoped>
.help-icon{
  margin-left: auto;
}
@media (max-width: 1536px) {
    .help-icon span {
        display: block !important;
    }
}
</style>